import { combineReducers } from 'redux';
import urlquery from './urlquery';


const reducerComp = combineReducers({
    urlquery
});

export default reducerComp



// WEBPACK FOOTER //
// ./src/services/reducers/index.js